// sync-start:standard-region-codes 262848992 https://github.com/Khan/webapp/blob/master/services/content-editing/standard_region/standard_region.go
export const STANDARD_US_REGION_CODE_TO_NAME = [
    // United States
    {code: "US-AL", name: "Alabama"},
    {code: "US-AK", name: "Alaska"},
    {code: "US-AS", name: "American Samoa"}, // Insular area
    {code: "US-AZ", name: "Arizona"},
    {code: "US-AR", name: "Arkansas"},
    {code: "US-CA", name: "California"},
    {code: "US-CO", name: "Colorado"},
    {code: "US-CT", name: "Connecticut"},
    {code: "US-DE", name: "Delaware"},
    {code: "US-DC", name: "District of Columbia"}, // Federal district
    {code: "US-FL", name: "Florida"},
    {code: "US-GA", name: "Georgia"},
    {code: "US-GU", name: "Guam"}, // Insular area
    {code: "US-HI", name: "Hawaii"},
    {code: "US-ID", name: "Idaho"},
    {code: "US-IL", name: "Illinois"},
    {code: "US-IN", name: "Indiana"},
    {code: "US-IA", name: "Iowa"},
    {code: "US-KS", name: "Kansas"},
    {code: "US-KY", name: "Kentucky"},
    {code: "US-LA", name: "Louisiana"},
    {code: "US-ME", name: "Maine"},
    {code: "US-MD", name: "Maryland"},
    {code: "US-MA", name: "Massachusetts"},
    {code: "US-MI", name: "Michigan"},
    {code: "US-MN", name: "Minnesota"},
    {code: "US-MS", name: "Mississippi"},
    {code: "US-MO", name: "Missouri"},
    {code: "US-MT", name: "Montana"},
    {code: "US-NE", name: "Nebraska"},
    {code: "US-NV", name: "Nevada"},
    {code: "US-NH", name: "New Hampshire"},
    {code: "US-NJ", name: "New Jersey"},
    {code: "US-NM", name: "New Mexico"},
    {code: "US-NY", name: "New York"},
    {code: "US-NC", name: "North Carolina"},
    {code: "US-ND", name: "North Dakota"},
    {code: "US-MP", name: "Northern Mariana Islands"}, // Insular area
    {code: "US-OH", name: "Ohio"},
    {code: "US-OK", name: "Oklahoma"},
    {code: "US-OR", name: "Oregon"},
    {code: "US-PA", name: "Pennsylvania"},
    {code: "US-PR", name: "Puerto Rico"}, // Insular area
    {code: "US-RI", name: "Rhode Island"},
    {code: "US-SC", name: "South Carolina"},
    {code: "US-SD", name: "South Dakota"},
    {code: "US-TN", name: "Tennessee"},
    {code: "US-TX", name: "Texas"},
    {code: "US-UT", name: "Utah"},
    {code: "US-VT", name: "Vermont"},
    {code: "US-VA", name: "Virginia"},
    {code: "US-WA", name: "Washington"},
    {code: "US-WV", name: "West Virginia"},
    {code: "US-WI", name: "Wisconsin"},
    {code: "US-WY", name: "Wyoming"},
    {code: "US-VI", name: "Virgin Islands, U.S."}, // Insular area
] as const;

export function GetStandardRegionName(regionCode: string): string {
    const entry = STANDARD_US_REGION_CODE_TO_NAME.find((entry) => {
        return entry.code === regionCode;
    });

    return entry ? entry.name : regionCode;
}

export type RegionEntry = {
    code: string;
    name: string;
};
// sync-end:standard-region-codes
